import styled from 'styled-components'

const ExpandablePanelStyle = styled.div`
  .expansionPanel {
    position: initial;
    box-shadow: none;
    background: ${props => props.theme.black4};
  }

  .shortened {
    background: ${props => props.theme.black4onBlack4};
  }

  .details {
    background: #fff;
    margin: ${props => (props.multiRow ? '0' : '0 12px')};
    border-radius: 4px;
    padding: 16px 24px;
  }

  .details.withoutBackground {
    background: none;
    padding: 0;
  }

  .title {
    width: 100%;
    border-bottom: 1px solid ${props => props.theme.black38};
  }

  .multi.expansionPanel {
    padding: 0;
    margin-bottom: 0;

    .title p {
      margin: 8px 0;
    }
  }
`

export default ExpandablePanelStyle
